<template>
  <v-container fluid grid-list-md align-center pa-0>
    <ComponentAdminReport />
  </v-container>
</template>

<script>
import ComponentAdminReport from "@/components/admin/ComponentAdminReport";
export default {
  components: {
    ComponentAdminReport
  }
};
</script>

<style scoped>
</style>